import { notificationApi } from '@/api'
import { ApiResult } from '@modals/RequiredEmailConfirmation/components/RequiredEmailConfirmationModal/utils/api'
import { NotificationChannel, UserNotificationSettings } from './types'

export const getUserNotificationsSettings = async (
  userId: number,
): Promise<ApiResult<UserNotificationSettings>> => {
  // return {
  //   data: {
  //     user: {
  //       id: 1234,
  //       name: 'Анна Иванова',
  //       email: 'anna.ivanova@example.com',
  //       avatar_path: '',
  //       role: 'children',
  //     } as IUser,
  //     canChangeParentNotification: true,
  //     isParentNotificationEnabled: true,
  //     notifications: [
  //       {
  //         id: 1,
  //         title: 'Отчет родителю',
  //         description: 'Уведомление о готовности отчета для родителя',
  //         active_channels: ['email', 'web'],
  //         all_channels: ['tg-bot', 'email', 'mobile', 'web'],
  //       },
  //       {
  //         id: 2,
  //         title: 'Напоминание о занятии',
  //         description: 'Уведомление перед началом занятия',
  //         active_channels: ['mobile', 'tg-bot'],
  //         all_channels: ['tg-bot', 'email', 'mobile', 'web'],
  //       },
  //       {
  //         id: 3,
  //         title: 'Проверка домашнего задания',
  //         description: 'Уведомление о проверенном домашнем задании',
  //         active_channels: ['web'],
  //         all_channels: ['mobile', 'web'],
  //       },
  //     ],
  //   },
  //   success: true,
  // }

  try {
    const res = await notificationApi.getUserNotificationSettings(userId)
    const success = res?.data?.status === 'success'

    return {
      data: success ? res?.data?.data : null,
      success,
      error: success ? undefined : res?.data?.error || res?.data?.message,
    }
  } catch (error) {
    console.error('Ошибка getUserNotificationsSettings:', error)

    return {
      data: null,
      success: false,
      error: String(error),
    }
  }
}

export const updateUserNotificationChannel = async (
  userId: number,
  notificationId: number,
  channel: NotificationChannel,
  enabled: boolean,
): Promise<ApiResult<boolean>> => {
  try {
    const data = new FormData()

    data.append('user_id', String(userId))
    data.append('notification_id', String(notificationId))
    data.append('channel', channel)
    data.append('is_enabled', String(enabled))

    const res = await notificationApi.updateUserNotificationChannel(data)
    const success = res?.data?.status === 'success'

    return {
      data: success,
      success,
      error: success ? undefined : res?.data?.error || res?.data?.message,
    }
  } catch (error) {
    console.error('Ошибка updateUserNotificationChannel:', error)

    return {
      data: null,
      success: false,
      error: String(error),
    }
  }
}

export const updateUserParentNotification = async (
  userId: number,
  enabled: boolean,
): Promise<ApiResult<boolean>> => {
  try {
    const data = new FormData()

    data.append('user_id', String(userId))
    data.append('is_enabled', String(enabled))

    const res = await notificationApi.updateUserParentNotification(data)
    const success = res?.data?.status === 'success'

    return {
      data: success,
      success,
      error: success ? undefined : res?.data?.error || res?.data?.message,
    }
  } catch (error) {
    console.error('Ошибка updateUserParentNotification:', error)

    return {
      data: null,
      success: false,
      error: String(error),
    }
  }
}
